// Auto-generated resource for Users — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const UsersKeys = {
  Validations: {
    AlreadyExists: 'Users.Validations.AlreadyExists',
    DoesNotExist: 'Users.Validations.DoesNotExist',
    CannotUpdateDeactivated: 'Users.Validations.CannotUpdateDeactivated',
    AlreadyDeactivated: 'Users.Validations.AlreadyDeactivated',
    AlreadyActive: 'Users.Validations.AlreadyActive',
    EmptyName: 'Users.Validations.EmptyName',
    NameTooLong: 'Users.Validations.NameTooLong',
    NameContainsControlChars: 'Users.Validations.NameContainsControlChars',
    PreferredWpmOutOfRange: 'Users.Validations.PreferredWpmOutOfRange',
    CueLengthInvalid: 'Users.Validations.CueLengthInvalid',
    AvatarRequired: 'Users.Validations.AvatarRequired',
    AvatarTooLong: 'Users.Validations.AvatarTooLong',
    InvalidAvatarContentType: 'Users.Validations.InvalidAvatarContentType',
    InvalidAvatarObjectKey: 'Users.Validations.InvalidAvatarObjectKey',
    EmptyEmail: 'Users.Validations.EmptyEmail',
    InvalidEmail: 'Users.Validations.InvalidEmail',
    EmptyMobile: 'Users.Validations.EmptyMobile',
    InvalidMobile: 'Users.Validations.InvalidMobile',
    MobileAlreadyRecorded: 'Users.Validations.MobileAlreadyRecorded',
    EmptyRole: 'Users.Validations.EmptyRole',
    EmailMismatch: 'Users.Validations.EmailMismatch',
    EmptyIpAddress: 'Users.Validations.EmptyIpAddress',
    EmailAlreadyInUse: 'Users.Validations.EmailAlreadyInUse',
    EmailChangeNotSupported: 'Users.Validations.EmailChangeNotSupported',
    RetentionKeepDaysOutOfRange: 'Users.Validations.RetentionKeepDaysOutOfRange',
    DefaultRecordingQualityRequired: 'Users.Validations.DefaultRecordingQualityRequired',
    AutoSaveRequiresPremium: 'Users.Validations.AutoSaveRequiresPremium',
    AutoDeleteRequiresPremium: 'Users.Validations.AutoDeleteRequiresPremium',
    UnsupportedCulture: 'Users.Validations.UnsupportedCulture',
    UnknownTimeZone: 'Users.Validations.UnknownTimeZone',
    InvalidUnsubscribeLink: 'Users.Validations.InvalidUnsubscribeLink',
  },
  RecordingSettings: {
    Updated: 'Users.RecordingSettings.Updated',
  },
  Security: {
    SessionExpired: 'Users.Security.SessionExpired',
    AccountDeactivated: 'Users.Security.AccountDeactivated',
  },
  OAuth: {
    ProviderNotSupported: 'Users.OAuth.ProviderNotSupported',
    AuthenticationSuccessful: 'Users.OAuth.AuthenticationSuccessful',
    LogoutSuccessful: 'Users.OAuth.LogoutSuccessful',
  },
  Account: {
    Deleted: 'Users.Account.Deleted',
    DeleteNotFound: 'Users.Account.DeleteNotFound',
    ExportExpired: 'Users.Account.ExportExpired',
    ExportNotFound: 'Users.Account.ExportNotFound',
  },
  Admin: {
    UsersCreated: 'Users.Admin.UsersCreated',
    AdminUserCreated: 'Users.Admin.AdminUserCreated',
    UserRolesUpdated: 'Users.Admin.UserRolesUpdated',
    UserRolesRemoved: 'Users.Admin.UserRolesRemoved',
    UsersDeactivated: 'Users.Admin.UsersDeactivated',
    UsersReactivated: 'Users.Admin.UsersReactivated',
    UserNotFound: 'Users.Admin.UserNotFound',
    RoleNotPresent: 'Users.Admin.RoleNotPresent',
    RoleEscalationDenied: 'Users.Admin.RoleEscalationDenied',
    UserRoleRequired: 'Users.Admin.UserRoleRequired',
    AdminRolesRootOnly: 'Users.Admin.AdminRolesRootOnly',
    SuperAdminFromRootOnly: 'Users.Admin.SuperAdminFromRootOnly',
  },
  Billing: {
    AlreadySubscribed: 'Users.Billing.AlreadySubscribed',
    NotSubscribed: 'Users.Billing.NotSubscribed',
    CheckoutFailed: 'Users.Billing.CheckoutFailed',
    SkuUnknown: 'Users.Billing.SkuUnknown',
    PaymentSucceeded: 'Users.Billing.PaymentSucceeded',
    NoBillingAccount: 'Users.Billing.NoBillingAccount',
    PortalFailed: 'Users.Billing.PortalFailed',
    TopUpRequiresPremium: 'Users.Billing.TopUpRequiresPremium',
  },
  Impersonation: {
    SelfDisallowed: 'Users.Impersonation.SelfDisallowed',
    AlreadyActive: 'Users.Impersonation.AlreadyActive',
    AdminTargetDisallowed: 'Users.Impersonation.AdminTargetDisallowed',
    TargetNotFound: 'Users.Impersonation.TargetNotFound',
    AdminNotFound: 'Users.Impersonation.AdminNotFound',
    ReasonRequired: 'Users.Impersonation.ReasonRequired',
    ActionDenied: 'Users.Impersonation.ActionDenied',
  },
  CreditAdjust: {
    TargetNotFound: 'Users.CreditAdjust.TargetNotFound',
    AdminNotFound: 'Users.CreditAdjust.AdminNotFound',
    AmountZero: 'Users.CreditAdjust.AmountZero',
    AmountOutOfRange: 'Users.CreditAdjust.AmountOutOfRange',
    ReasonRequired: 'Users.CreditAdjust.ReasonRequired',
    WouldGoNegative: 'Users.CreditAdjust.WouldGoNegative',
  },
  CreditGrant: {
    UserNotFound: 'Users.CreditGrant.UserNotFound',
  },
  PracticeReminders: {
    TurnedOff: 'Users.PracticeReminders.TurnedOff',
  },
  HomeMove: {
    ReasonRequired: 'Users.HomeMove.ReasonRequired',
    NoSuchMove: 'Users.HomeMove.NoSuchMove',
    TooLateToAbort: 'Users.HomeMove.TooLateToAbort',
    NotCommitted: 'Users.HomeMove.NotCommitted',
    NotActivated: 'Users.HomeMove.NotActivated',
    Refused: {
      SingleCell: 'Users.HomeMove.Refused.SingleCell',
      UnknownTarget: 'Users.HomeMove.Refused.UnknownTarget',
      NoAccount: 'Users.HomeMove.Refused.NoAccount',
      NoDirectoryRow: 'Users.HomeMove.Refused.NoDirectoryRow',
      NotHomedHere: 'Users.HomeMove.Refused.NotHomedHere',
      RowNotActive: 'Users.HomeMove.Refused.RowNotActive',
      DirectoryUnavailable: 'Users.HomeMove.Refused.DirectoryUnavailable',
      MoveInProgressOnCell: 'Users.HomeMove.Refused.MoveInProgressOnCell',
      MovedRecently: 'Users.HomeMove.Refused.MovedRecently',
      TargetUnreachable: 'Users.HomeMove.Refused.TargetUnreachable',
      VersionSkew: 'Users.HomeMove.Refused.VersionSkew',
      TargetHoldsAccountData: 'Users.HomeMove.Refused.TargetHoldsAccountData',
      OpenDeletion: 'Users.HomeMove.Refused.OpenDeletion',
      ReviewStarted: 'Users.HomeMove.Refused.ReviewStarted',
      LiveConversation: 'Users.HomeMove.Refused.LiveConversation',
      RecentStagedUpload: 'Users.HomeMove.Refused.RecentStagedUpload',
    },
  },
} as const;

export const UsersValues = {
  'default': {
    'Account.DeleteNotFound': 'No account to delete.',
    'Account.Deleted': 'Your account has been deleted.',
    'Account.ExportExpired': 'This download link has expired. The files have been deleted.',
    'Account.ExportNotFound': 'This download link is not valid.',
    'Admin.AdminRolesRootOnly': 'Only a SuperAdmin can grant or remove admin roles.',
    'Admin.AdminUserCreated': 'Admin user created successfully',
    'Admin.RoleEscalationDenied': 'You cannot grant or manage a role higher than your own.',
    'Admin.RoleNotPresent': 'User does not have that role',
    'Admin.SuperAdminFromRootOnly': 'SuperAdmin comes only from the ROOT_ADMIN list in the deployment.',
    'Admin.UserNotFound': 'User does not exist',
    'Admin.UserRoleRequired': 'Every account keeps the User role. Deactivate the account to cut its access.',
    'Admin.UserRolesRemoved': 'User role removed successfully',
    'Admin.UserRolesUpdated': 'User roles updated successfully',
    'Admin.UsersCreated': 'User created successfully',
    'Admin.UsersDeactivated': 'User deactivated successfully',
    'Admin.UsersReactivated': 'User reactivated successfully',
    'Billing.AlreadySubscribed': 'You already have an active subscription',
    'Billing.CheckoutFailed': 'Could not start checkout. Please try again.',
    'Billing.NoBillingAccount': 'No billing account yet — make a purchase first.',
    'Billing.NotSubscribed': 'No active subscription to cancel',
    'Billing.PaymentSucceeded': 'Thanks — {Quantity} AI credits added.',
    'Billing.PortalFailed': 'Could not open the billing portal. Please try again.',
    'Billing.SkuUnknown': 'Unknown product.',
    'Billing.TopUpRequiresPremium': 'Storage top-ups require an active Premium subscription.',
    'CreditAdjust.AdminNotFound': 'Admin user record not found',
    'CreditAdjust.AmountOutOfRange': 'Adjustment amount must be between {0} and {1}',
    'CreditAdjust.AmountZero': 'Adjustment amount must be non-zero',
    'CreditAdjust.ReasonRequired': 'A reason for the credit adjustment is required for audit',
    'CreditAdjust.TargetNotFound': 'Target user does not exist',
    'CreditAdjust.WouldGoNegative': 'Adjustment would push balance below zero',
    'CreditGrant.UserNotFound': 'User does not exist',
    'HomeMove.NoSuchMove': 'There is no such move on this cell.',
    'HomeMove.NotActivated': 'The target still would not take up the account: {0}',
    'HomeMove.NotCommitted': 'This move has not finished, so there is nothing to activate yet. Its phase is {0}.',
    'HomeMove.ReasonRequired': 'A move needs a reason, of at most 1000 characters.',
    'HomeMove.Refused.DirectoryUnavailable': 'The directory did not answer. Nothing was changed; try again.',
    'HomeMove.Refused.LiveConversation': 'This user is in a live conversation. Try again once it ends.',
    'HomeMove.Refused.MoveInProgressOnCell': 'Another move is running on this cell. One runs at a time.',
    'HomeMove.Refused.MovedRecently': 'This account moved at {0}. An account may move once in 24 hours.',
    'HomeMove.Refused.NoAccount': 'This user has no account on this cell.',
    'HomeMove.Refused.NoDirectoryRow': 'The directory has no row for this account, so it cannot be moved.',
    'HomeMove.Refused.NotHomedHere': 'This account is homed on {0}. Start the move from that cell\'s admin host.',
    'HomeMove.Refused.OpenDeletion': 'This account has an open deletion, so it cannot be moved.',
    'HomeMove.Refused.RecentStagedUpload': 'This user uploaded a recording within the last hour, which may still be landing. Try again later. ({0})',
    'HomeMove.Refused.ReviewStarted': 'An AI Review of this account is running. Try again once it finishes.',
    'HomeMove.Refused.RowNotActive': 'The directory says this account is {0}, so it cannot be moved now.',
    'HomeMove.Refused.SingleCell': 'This deployment has one cell, so there is nowhere to move to.',
    'HomeMove.Refused.TargetHoldsAccountData': '{0}',
    'HomeMove.Refused.TargetUnreachable': 'The target cell did not answer: {0}',
    'HomeMove.Refused.UnknownTarget': 'Cell "{0}" is not another cell this one knows.',
    'HomeMove.Refused.VersionSkew': 'The two cells run different releases: {0}',
    'HomeMove.TooLateToAbort': 'This move can no longer be aborted: it is past the commit point or already ending. The way back is another move.',
    'Impersonation.ActionDenied': 'This action is unavailable while impersonating another user',
    'Impersonation.AdminNotFound': 'Admin user record not found',
    'Impersonation.AdminTargetDisallowed': 'Cannot impersonate another administrator',
    'Impersonation.AlreadyActive': 'Already impersonating another user; stop first',
    'Impersonation.ReasonRequired': 'A reason for impersonation is required for audit',
    'Impersonation.SelfDisallowed': 'Cannot impersonate yourself',
    'Impersonation.TargetNotFound': 'Target user does not exist',
    'OAuth.AuthenticationSuccessful': 'OAuth authentication successful',
    'OAuth.LogoutSuccessful': 'Logged out successfully',
    'OAuth.ProviderNotSupported': 'OAuth provider \'{0}\' is not supported',
    'PracticeReminders.TurnedOff': 'Practice reminders are off.',
    'RecordingSettings.Updated': 'Your recording settings have been updated.',
    'Security.AccountDeactivated': 'Account is deactivated',
    'Security.SessionExpired': 'Your session has ended. Please sign in again.',
    'Validations.AlreadyActive': 'User is already active',
    'Validations.AlreadyDeactivated': 'User is already deactivated',
    'Validations.AlreadyExists': 'User already exists',
    'Validations.AutoDeleteRequiresPremium': 'Auto-delete is a Premium feature',
    'Validations.AutoSaveRequiresPremium': 'Auto Save is a Premium feature',
    'Validations.AvatarRequired': 'Avatar cannot be empty',
    'Validations.AvatarTooLong': 'Avatar reference is too long',
    'Validations.CannotUpdateDeactivated': 'Cannot update deactivated user',
    'Validations.CueLengthInvalid': 'Choose a cue length: short, normal or long',
    'Validations.DefaultRecordingQualityRequired': 'Default recording quality cannot be null',
    'Validations.DoesNotExist': 'User does not exist',
    'Validations.EmailAlreadyInUse': 'This email address is already in use',
    'Validations.EmailChangeNotSupported': 'An account\'s email cannot be changed. A new email means a new account.',
    'Validations.EmailMismatch': 'Email does not match user record',
    'Validations.EmptyEmail': 'Email cannot be empty',
    'Validations.EmptyIpAddress': 'IP address cannot be empty',
    'Validations.EmptyMobile': 'Mobile number cannot be empty',
    'Validations.EmptyName': 'Name cannot be empty',
    'Validations.EmptyRole': 'Role cannot be empty',
    'Validations.InvalidAvatarContentType': 'Avatar image must be one of: {0}',
    'Validations.InvalidAvatarObjectKey': 'Avatar object key does not match the signed upload',
    'Validations.InvalidEmail': 'Invalid email address: {0}',
    'Validations.InvalidMobile': 'Invalid mobile number: {0}',
    'Validations.InvalidUnsubscribeLink': 'This unsubscribe link is not valid. Turn practice reminders off in your profile instead.',
    'Validations.MobileAlreadyRecorded': 'A mobile number is already recorded for this account and cannot be changed',
    'Validations.NameContainsControlChars': 'Name contains invalid control characters',
    'Validations.NameTooLong': 'Name must be {0} characters or fewer',
    'Validations.PreferredWpmOutOfRange': 'Preferred words-per-minute must be between {0} and {1}',
    'Validations.RetentionKeepDaysOutOfRange': 'Keep-for days must be between {0} and {1}',
    'Validations.UnknownTimeZone': 'This timezone is not recognised',
    'Validations.UnsupportedCulture': 'This language is not supported',
  },
  'vi-VN': {
    'Account.DeleteNotFound': 'Không có tài khoản nào để xóa.',
    'Account.Deleted': 'Tài khoản của bạn đã bị xóa.',
    'Account.ExportExpired': 'Liên kết tải xuống này đã hết hạn. Các tệp đã bị xóa.',
    'Account.ExportNotFound': 'Liên kết tải xuống này không hợp lệ.',
    'Admin.AdminRolesRootOnly': 'Chỉ SuperAdmin mới có thể cấp hoặc gỡ vai trò quản trị.',
    'Admin.AdminUserCreated': 'Tạo người dùng quản trị thành công',
    'Admin.RoleEscalationDenied': 'Bạn không thể cấp hoặc quản lý vai trò cao hơn vai trò của chính mình.',
    'Admin.RoleNotPresent': 'Người dùng không có vai trò đó',
    'Admin.SuperAdminFromRootOnly': 'Vai trò SuperAdmin chỉ đến từ danh sách ROOT_ADMIN của bản triển khai.',
    'Admin.UserNotFound': 'Người dùng không tồn tại',
    'Admin.UserRoleRequired': 'Mọi tài khoản đều giữ vai trò User. Hãy vô hiệu hóa tài khoản để cắt quyền truy cập.',
    'Admin.UserRolesRemoved': 'Gỡ vai trò người dùng thành công',
    'Admin.UserRolesUpdated': 'Cập nhật vai trò người dùng thành công',
    'Admin.UsersCreated': 'Tạo người dùng thành công',
    'Admin.UsersDeactivated': 'Vô hiệu hóa người dùng thành công',
    'Admin.UsersReactivated': 'Kích hoạt lại người dùng thành công',
    'Billing.AlreadySubscribed': 'Bạn đã có gói đăng ký đang hoạt động',
    'Billing.CheckoutFailed': 'Không thể bắt đầu thanh toán. Vui lòng thử lại.',
    'Billing.NoBillingAccount': 'Chưa có tài khoản thanh toán — hãy mua hàng trước.',
    'Billing.NotSubscribed': 'Không có gói đăng ký nào để hủy',
    'Billing.PaymentSucceeded': 'Cảm ơn — đã thêm {Quantity} tín dụng AI.',
    'Billing.PortalFailed': 'Không thể mở cổng thanh toán. Vui lòng thử lại.',
    'Billing.SkuUnknown': 'Sản phẩm không xác định.',
    'Billing.TopUpRequiresPremium': 'Gói bổ sung dung lượng cần một gói đăng ký Cao cấp đang hoạt động.',
    'CreditAdjust.AdminNotFound': 'Không tìm thấy bản ghi quản trị viên',
    'CreditAdjust.AmountOutOfRange': 'Mức điều chỉnh phải nằm trong khoảng từ {0} đến {1}',
    'CreditAdjust.AmountZero': 'Mức điều chỉnh phải khác không',
    'CreditAdjust.ReasonRequired': 'Cần có lý do điều chỉnh tín dụng để ghi nhận kiểm toán',
    'CreditAdjust.TargetNotFound': 'Người dùng mục tiêu không tồn tại',
    'CreditAdjust.WouldGoNegative': 'Điều chỉnh sẽ khiến số dư xuống dưới 0',
    'CreditGrant.UserNotFound': 'Người dùng không tồn tại',
    'HomeMove.NoSuchMove': 'Không có lượt chuyển này trên cụm máy chủ này.',
    'HomeMove.NotActivated': 'Cụm đích vẫn chưa nhận tài khoản: {0}',
    'HomeMove.NotCommitted': 'Lượt chuyển này chưa xong nên chưa có gì để kích hoạt. Giai đoạn hiện tại: {0}.',
    'HomeMove.ReasonRequired': 'Cần có lý do chuyển, tối đa 1000 ký tự.',
    'HomeMove.Refused.DirectoryUnavailable': 'Danh bạ không phản hồi. Chưa có gì thay đổi; hãy thử lại.',
    'HomeMove.Refused.LiveConversation': 'Người dùng này đang trong một cuộc hội thoại trực tiếp. Hãy thử lại khi cuộc đó kết thúc.',
    'HomeMove.Refused.MoveInProgressOnCell': 'Một lượt chuyển khác đang chạy trên cụm này. Mỗi lần chỉ chạy một lượt.',
    'HomeMove.Refused.MovedRecently': 'Tài khoản này đã chuyển lúc {0}. Mỗi tài khoản chỉ được chuyển một lần trong 24 giờ.',
    'HomeMove.Refused.NoAccount': 'Người dùng này không có tài khoản trên cụm này.',
    'HomeMove.Refused.NoDirectoryRow': 'Danh bạ không có bản ghi của tài khoản này nên không thể chuyển.',
    'HomeMove.Refused.NotHomedHere': 'Tài khoản này thuộc cụm {0}. Hãy bắt đầu lượt chuyển từ trang quản trị của cụm đó.',
    'HomeMove.Refused.OpenDeletion': 'Tài khoản này đang có yêu cầu xóa nên không thể chuyển.',
    'HomeMove.Refused.RecentStagedUpload': 'Người dùng này vừa tải lên một bản ghi trong vòng một giờ qua, có thể vẫn đang xử lý. Hãy thử lại sau. ({0})',
    'HomeMove.Refused.ReviewStarted': 'Một lượt Đánh giá AI của tài khoản này đang chạy. Hãy thử lại khi lượt đó xong.',
    'HomeMove.Refused.RowNotActive': 'Danh bạ ghi tài khoản này đang ở trạng thái {0} nên chưa thể chuyển.',
    'HomeMove.Refused.SingleCell': 'Hệ thống này chỉ có một cụm máy chủ nên không có nơi để chuyển đến.',
    'HomeMove.Refused.TargetHoldsAccountData': '{0}',
    'HomeMove.Refused.TargetUnreachable': 'Cụm đích không phản hồi: {0}',
    'HomeMove.Refused.UnknownTarget': 'Cụm "{0}" không phải là một cụm khác mà cụm này biết đến.',
    'HomeMove.Refused.VersionSkew': 'Hai cụm đang chạy các phiên bản khác nhau: {0}',
    'HomeMove.TooLateToAbort': 'Không thể hủy lượt chuyển này nữa: đã qua điểm cam kết hoặc đang kết thúc. Muốn quay lại thì thực hiện một lượt chuyển khác.',
    'Impersonation.ActionDenied': 'Hành động này không khả dụng khi đang đóng vai người dùng khác',
    'Impersonation.AdminNotFound': 'Không tìm thấy bản ghi quản trị viên',
    'Impersonation.AdminTargetDisallowed': 'Không thể đóng vai một quản trị viên khác',
    'Impersonation.AlreadyActive': 'Đang đóng vai một người dùng khác; hãy dừng trước',
    'Impersonation.ReasonRequired': 'Cần có lý do đóng vai để ghi nhận kiểm toán',
    'Impersonation.SelfDisallowed': 'Không thể đóng vai chính mình',
    'Impersonation.TargetNotFound': 'Người dùng mục tiêu không tồn tại',
    'OAuth.AuthenticationSuccessful': 'Xác thực OAuth thành công',
    'OAuth.LogoutSuccessful': 'Đăng xuất thành công',
    'OAuth.ProviderNotSupported': 'Nhà cung cấp OAuth \'{0}\' không được hỗ trợ',
    'PracticeReminders.TurnedOff': 'Đã tắt lời nhắc luyện tập.',
    'RecordingSettings.Updated': 'Cài đặt ghi âm của bạn đã được cập nhật.',
    'Security.AccountDeactivated': 'Tài khoản đã bị vô hiệu hóa',
    'Security.SessionExpired': 'Phiên đăng nhập đã kết thúc. Vui lòng đăng nhập lại.',
    'Validations.AlreadyActive': 'Người dùng đã được kích hoạt',
    'Validations.AlreadyDeactivated': 'Người dùng đã bị vô hiệu hóa',
    'Validations.AlreadyExists': 'Người dùng đã tồn tại',
    'Validations.AutoDeleteRequiresPremium': 'Tự động xóa là tính năng Cao cấp',
    'Validations.AutoSaveRequiresPremium': 'Tự động lưu là tính năng Cao cấp',
    'Validations.AvatarRequired': 'Ảnh đại diện không được để trống',
    'Validations.AvatarTooLong': 'Tham chiếu ảnh đại diện quá dài',
    'Validations.CannotUpdateDeactivated': 'Không thể cập nhật người dùng đã bị vô hiệu hóa',
    'Validations.CueLengthInvalid': 'Hãy chọn độ dài gợi ý: ngắn, vừa hoặc dài',
    'Validations.DefaultRecordingQualityRequired': 'Chất lượng ghi mặc định không được để trống',
    'Validations.DoesNotExist': 'Người dùng không tồn tại',
    'Validations.EmailAlreadyInUse': 'Địa chỉ email này đã được sử dụng',
    'Validations.EmailChangeNotSupported': 'Không thể thay đổi email của tài khoản. Email mới nghĩa là tài khoản mới.',
    'Validations.EmailMismatch': 'Email không khớp với bản ghi người dùng',
    'Validations.EmptyEmail': 'Email không được để trống',
    'Validations.EmptyIpAddress': 'Địa chỉ IP không được để trống',
    'Validations.EmptyMobile': 'Số điện thoại không được để trống',
    'Validations.EmptyName': 'Tên không được để trống',
    'Validations.EmptyRole': 'Vai trò không được để trống',
    'Validations.InvalidAvatarContentType': 'Ảnh đại diện phải là một trong các định dạng: {0}',
    'Validations.InvalidAvatarObjectKey': 'Object key của ảnh đại diện không khớp với lần tải lên đã ký',
    'Validations.InvalidEmail': 'Địa chỉ email không hợp lệ: {0}',
    'Validations.InvalidMobile': 'Số điện thoại không hợp lệ: {0}',
    'Validations.InvalidUnsubscribeLink': 'Liên kết hủy đăng ký này không hợp lệ. Hãy tắt lời nhắc luyện tập trong hồ sơ của bạn.',
    'Validations.MobileAlreadyRecorded': 'Tài khoản này đã ghi nhận số điện thoại và không thể thay đổi',
    'Validations.NameContainsControlChars': 'Tên chứa ký tự điều khiển không hợp lệ',
    'Validations.NameTooLong': 'Tên phải có tối đa {0} ký tự',
    'Validations.PreferredWpmOutOfRange': 'Số từ mỗi phút ưa thích phải nằm trong khoảng {0} đến {1}',
    'Validations.RetentionKeepDaysOutOfRange': 'Số ngày giữ lại phải nằm trong khoảng {0} đến {1}',
    'Validations.UnknownTimeZone': 'Múi giờ này không hợp lệ',
    'Validations.UnsupportedCulture': 'Ngôn ngữ này không được hỗ trợ',
  },
} as const;

